"use strict";

import About from "../views/pages/About.js";
import PostShow from "../views/pages/PostShow.js";
import Error404 from "../views/error-pages/Error404.js";
import Categories from "../views/pages/Categories.js";
import { Leagues } from "../views/pages/League.js";
import GameByLeague from "../views/pages/GameByLeague.js";
import Match from "../views/pages/Match.js";
import LiveMatch from "../views/pages/LiveMatch.js";
import MyBets from "../views/pages/MyBets.js";
import MyBetsUsers from "../views/pages/MyBetsUsers.js";
import MyBetsUserDetails from "../views/pages/MyBetsUserDetails.js";
import AccountBalance from "../views/pages/AccountBalance.js";
import SmFinances from "../views/pages/SmFinances.js";
import CurrentBalance from "../views/pages/CurrentBalance.js";
import CreateUsers from "../views/pages/CreateUsers.js";
// import Users from "../views/pages/Users.js";
import UsersNew from "../views/pages/UsersNew.js";
// import UserProfile from "../views/pages/UserProfile.js";
import UserProfileNew from "../views/pages/UserProfileNew.js";
import LiveCasino from "../views/pages/LiveCasino.js";

import Landing from "../views/pages/Landing.js";
import MatchHour from "../views/pages/MatchHour.js";
import InPlay from "../views/pages/InPlay.js";
import Jackpot from "../views/pages/Jackpot.js";
import ChangePassword from "../views/pages/ChangePassword.js";
import JackpotModal from "../views/components/JackpotModal.js";

import Header from "../views/components/Header.js";
import Login from "../views/components/Login.js";
import Slots from "../views/pages/Slots.js";
import NewSlots from "../views/pages/NewSlots.js";
import { Leftpanel } from "../views/components/Leftpanel.js";
import Betslip from "../views/components/Betslip.js";

import Bottombar from "../views/components/Bottombar.js";
import Utils from "../services/Utils.js";
import { getCurrentBalance } from "../js/api/balance.js";
import { getJackPotValue } from "./api/jackpot.js";
import MyBetsUsersAgent from "../views/pages/MyBetsUsers_Agent.js";
import TranslationService, { _t } from "../services/TranslationService.js";
import {
  checkForUserGroup,
  getUserGroup,
  transformSingleCoef,
} from "../services/UserGroup.js";
import Slots2 from "../views/pages/Slots2.js";
import { getTitle, LOGIN_PROTECTED } from "./constants/global-variables.js";
import TermsPage from "../views/pages/Terms.js";
import AccountBalanceNew from "../views/pages/AccountBalanceNew.js";
import Deluxe from "../views/pages/Deluxe.js";
import Stargames from "../views/pages/Stargame.js";
import UserPrivileges from "../views/pages/UserPrivileges.js";
import UserConfig from "../views/pages/UserConfig.js";

HTMLElement.prototype.textNodes = function () {
  return [...this.childNodes].filter((node) => {
    return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "";
  });
};

var routes = {
  "/": Landing,
  "/landing/:id": MatchHour,
  "/about": About,
  "/terms": TermsPage,
  "/p/:id": PostShow,
  "/categories/:id": Categories,
  "/league/:id": Leagues,
  "/games/:id": GameByLeague,
  "/match/:id": Match,
  "/livematch/:id": LiveMatch,
  "/inplay": InPlay,
  "/inplay/:id": InPlay,
  "/mybets": MyBets,
  "/mybetsusers": MyBetsUsers,
  "/mybetsusers/:id": MyBetsUsers,
  "/mybetsusers-agent": MyBetsUsersAgent,
  "/mybetsuserdetails/:id": MyBetsUserDetails,
  "/changepassword": ChangePassword,
  "/accountbalance": AccountBalanceNew,
  // "/accountbalance": AccountBalance,
  // "/accountbalance-new": AccountBalanceNew,
  "/smfinances": SmFinances,
  "/currentbalance": CurrentBalance,
  "/createnewuser": CreateUsers,
  // "/users": Users,
  "/users": UsersNew,
  // "/old-slots": Slots,
  "/slots": Slots, // NewSlots,
  "/deluxe": Deluxe,
  "/stargames": Stargames,
  "/userprofile/:id": UserProfileNew,
  "/userconfig/:id": UserConfig,
  "/userprivileges/:id": UserPrivileges,
  "/jackpot": Jackpot,
  "/live-casino": LiveCasino,
};

var socket = io("//omega.socketi355.com:1440", { transports: ["websocket"] });

var on_unloadFunction;

socket.on("jackpot.released", async function (res, callback) {
  if (
    localStorage.getItem("username").toLowerCase() == res.username.toLowerCase()
  ) {
    if (res.from_client) return;

    if (res.released) {
      await JackpotModal.after_render();

      setTimeout(() => {
        JackpotModal.show(5000, res.value, res.type);
      }, 3000);
    } else if (res.checking) {
      callback(localStorage.getItem("isOnSlots") == "true");
    }
  }
});

socket.on("new-coefs", function (res) {
  if (!res || !res.coefs) return;

  const userGroup = getUserGroup(); // Fetch user group
  res.coefs.forEach((data) => {
    data = transformSingleCoef(data, userGroup);

    var div = document.getElementsByClassName(data.coef_id)[0];

    var span = document.getElementsByClassName(data.coef_id + "-span");
    var bs = document.getElementsByClassName(data.coef_id + "-bs");
    if (div) {
      if (
        document.getElementsByClassName(data.coef_id)[0].children.length < 2
      ) {
        // document.getElementsByClassName(data.coef_id)[0].innerHTML = (
        //   Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        // ).toFixed(2);

        document
          .getElementsByClassName(data.coef_id)[0]
          .textNodes()[0].textContent = (
          Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        ).toFixed(2);
      }

      document
        .getElementsByClassName(data.coef_id)[0]
        .setAttribute(
          "match-odd",
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2),
        );
    }
    if (bs) {
      let coefHasChanged = localStorage.getItem("coefHasChanged");
      for (let index = 0; index < bs.length; index++) {
        let element = bs[index];
        const oldPrice = element.getAttribute("match-odd")
          ? element.getAttribute("match-odd")
          : element.outerText;
        if (
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2) ==
          (Math.floor(parseFloat(oldPrice) * 100) / 100).toFixed(2)
        )
          continue;
        let color =
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2) >
          (Math.floor(parseFloat(oldPrice) * 100) / 100).toFixed(2)
            ? "green"
            : "red";

        element.setAttribute(
          "match-odd",
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2),
        );
        element.innerHTML = `<span style=" text-decoration: line-through;">${(
          Math.floor((parseFloat(oldPrice) + Number.EPSILON) * 100) / 100
        ).toFixed(2)}</span><span style="color:${color}">${(
          Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        ).toFixed(2)}</span>`;

        coefHasChanged = true;
      }

      calculatePrice();

      if (coefHasChanged == true) {
        localStorage.setItem("coefHasChanged", coefHasChanged);
        $("#btnDescription").text("Prano ndryshimet");
        $("#valueIcon").text("");
        $("#placeBetValue").text("");
      }
    }

    if (span) {
      for (let index = 0; index < span.length; index++) {
        let element = span[index];
        element.setAttribute(
          "match-odd",
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2),
        );
        element.innerHTML = `<span>${(
          Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        ).toFixed(2)}</span>`;
      }

      calculatePrice();
    }

    updateCoefLocalStorage(data.coef_id, data.odd);
  });

  updateMatch();
});

socket.on("delete-live-game", function (data) {
  var liveGame = document.getElementById(data.id);

  if (liveGame) {
    liveGame.parentNode.removeChild(liveGame);
    //liveGame.innerHTML = "";
  }
});

socket.on("delete-live-coef", function (data) {
  var liveCoef = document.getElementsByClassName(`${data.id}-coef`);

  if (liveCoef && liveCoef[0]) {
    liveCoef[0].innerText = "1.00";
  }
});

function eraseCache(version) {
  window.location = window.location.href.split("?")[0] + "?v=" + version;
}

var setDefaults = async function () {
  try {
    if (location.host === "baste247.com") {
      $("#casino-img").attr("src", "img/casino-img2.jpeg");
      $(".slotsHolderScroll.casino").css({ paddingBottom: "207px" });
    } else if (location.host === "eternawin.it") {
      $("#casino-img").attr("src", "img/casino-img3.jpeg");
      $(".slotsHolderScroll.casino").css({ paddingBottom: "207px" });
      TranslationService.defaultLang = "en";
      // Set italian first language
      TranslationService.languages = TranslationService.languages.sort(
        (a, b) => {
          if (a.key === "en") return -1;
          if (b.key === "en") return 1;
          return 0;
        },
      );
    } else if (location.host === "zbavitu365.com") {
      $("#casino-img").attr("src", "img/casino-img4.jpeg");
      $(".slotsHolderScroll.casino").css({ paddingBottom: "207px" });
    } else if (location.host === "euro365.live") {
      $("#casino-img").attr("src", "img/casino-img5.jpg");
      $(".slotsHolderScroll.casino").css({ paddingBottom: "207px" });
    } else if (location.host === "euro365.co") {
      $("#casino-img").attr("src", "img/casino-img6.jpeg");
      $(".slotsHolderScroll.casino").css({ paddingBottom: "207px" });
    }

    // Remove Albanian language for agwin21.net
    if (
      location.hostname == "agwin21.net" ||
      location.hostname == "mobile24.live" ||
      location.hostname == "bet27.live"
    ) {
      TranslationService.defaultLang = "en";
      const index = TranslationService.languages.findIndex(
        (l) => l.key === "sq",
      );
      if (index > -1) {
        TranslationService.languages.splice(index, 1);
      }
    } else if (
      location.hostname == "swissplay365.com" ||
      location.hostname == "romaplay365.com"
    ) {
      $("#casino-img").attr("src", "img/casino-img-2.jpeg");
      $(".slotsHolderScroll.casino").css({ height: "auto" });
      $(".slotsHolderScroll.casino .scrollHelper2").css({ height: "auto" });
      $(".slotsHolderScroll.casino .slotsItem").css({ height: "auto" });
    }

    await TranslationService.loadTranslations().then(() => {
      TranslationService.translateStatics();
    });
  } catch {}

  localStorage.setItem("isOnSlots", false);

  const lastVersionDate = localStorage.getItem("version-date-1");
  const ONE_HOUR = 60 * 60 * 1000;

  if (!lastVersionDate || new Date() - new Date(lastVersionDate) > ONE_HOUR) {
    localStorage.setItem("version-date-1", new Date());
    eraseCache(new Date().getTime());
  }

  var header = null || document.getElementById("header_container");
  var footer = null || document.getElementById("footer_container");
  var betslip = null || document.getElementById("betslip");

  header.innerHTML = `${await Header.render()}  ${await JackpotModal.render()}`;
  await Header.after_render();

  betslip.innerHTML = await Betslip.render();
  await Betslip.after_render();

  footer.innerHTML = await Bottombar.render();
  await Bottombar.after_render();
  // await IframeModal.after_render();

  var itemArray = JSON.parse(localStorage.getItem("addObject")) || [];
  itemArray.forEach((item) => {
    socket.emit("connectToRoom", { room: item.gameId });
  });

  // Set title and modal titles
  document.title = getTitle();
  $(".messageModal").each(function (e) {
    $(this).find(".messageHolder span").text(getTitle());
  });
};

var router = async function () {
  var leftpanel = null || document.getElementById("leftpanel_container");
  var login = null || document.getElementById("login_container");
  var content = null || document.getElementById("content_container");
  let request = Utils.parseRequestURL();

  let parsedURL =
    (request.resource ? "/" + request.resource : "/") +
    (request.id ? "/:id" : "") +
    (request.verb ? "/" + request.verb : "");

  // if (parsedURL == "/slots") {
  //   $("body").addClass("bg-black");
  // } else {
  //   $("body").removeClass("bg-black");
  // }
  await saveJackpotValue();

  login.innerHTML = await Login.render();
  await Login.after_render();

  leftpanel.innerHTML = await Leftpanel.render();
  await Leftpanel.after_render();

  let page = routes[parsedURL] ? routes[parsedURL] : Error404;

  // console.log(parsedURL);

  $("#contentLoader").append(
    `<div class="loaderWrapper">
                  <div class="loader"></div>
              </div>`,
  );

  if (parsedURL === "/") {
    $("body").addClass("mainHomePage");
    $("body .logo").addClass("active");
  } else {
    $("body").removeClass("mainHomePage");
    $("body .logo").removeClass("active");
  }

  if (parsedURL === "/mybets" || parsedURL === "/mybetsusers") {
    $("body #inPlayPage").removeClass("active");
    $("body #myBetsPage").addClass("active");
  } else {
    $("body #myBetsPage").removeClass("active");
  }

  let body = $("html, body");
  body.stop().animate({ scrollTop: 0 }, 0, "swing");
  $("body").removeClass("menuOpened");

  if (on_unloadFunction) on_unloadFunction(socket);

  if (!parsedURL.startsWith("/mybets")) {
    localStorage.removeItem("betsStartDate");
    localStorage.removeItem("betsEndDate");
  }

  content.innerHTML = await page.render();
  if (page.hideFooterCasino === true) {
    $(".slotsWrapper").hide();
  } else {
    $(".slotsWrapper").show();
  }
  await page.after_render(socket);
  on_unloadFunction = page.on_unload;
  await updateMatch();
  $("body .loaderWrapper").remove();

  setCurrentBalance();
};

$("body").on("click", "#myBetsPage", function () {
  localStorage.removeItem("betsStartDate");
  localStorage.removeItem("betsEndDate");
});

async function loadLiveCasino() {
  window.location.href = "#/live-casino";
}

async function saveJackpotValue() {
  const value = await getJackPotValue();
  if (value) {
    localStorage.setItem(
      "jackpot_value",
      (
        Math.floor((parseFloat(value.actual_jackpot) + Number.EPSILON) * 100) /
        100
      ).toFixed(2),
    );

    localStorage.setItem(
      "jackpot_live",
      (
        Math.floor(
          (parseFloat(value.actual_jackpot_live) + Number.EPSILON) * 100,
        ) / 100
      ).toFixed(2),
    );

    localStorage.setItem(
      "jackpot_prematch",
      (
        Math.floor(
          (parseFloat(value.actual_jackpot_prematch) + Number.EPSILON) * 100,
        ) / 100
      ).toFixed(2),
    );
  }
}
if (axios && axios.interceptors && axios.interceptors.response) {
  // Add bearer token to all requests if access_token is present
  axios.interceptors.request.use(function (config) {
    if (localStorage.getItem("access_token")) {
      config.headers.Authorization = `Bearer ${localStorage.getItem(
        "access_token",
      )}`;
    }
    return config;
  });
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (!response || (response && !response.data)) {
        return response;
      }

      if (response.data.error == "Expired token") {
        localStorage.removeItem("role");
        localStorage.removeItem("name");
        localStorage.removeItem("access_token");
        localStorage.removeItem("surname");
        localStorage.clear();
        location.reload(true);
      } else return response;
    },
    function (error) {
      if (
        error.response.status === 401 &&
        localStorage.getItem("access_token")
      ) {
        localStorage.clear();
        location.reload(true);
      }
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    },
  );
}
var i = 0;

function getCombinations(input, size) {
  var results = [],
    result,
    mask,
    total = Math.pow(2, input.length);
  for (mask = 0; mask < total; mask++) {
    result = [];
    i = input.length - 1;
    do {
      if ((mask & (1 << i)) !== 0) {
        result.push(input[i]);
      }
    } while (i--);

    //ne qofte se duhen edhe bastet teke edhe vareja duhet ky rresht
    // if (result.length <= size && result.length > 0) {
    //perndryshe duhet ky
    if (result.length == size && result.length > 1) {
      results.push(result);
    }
  }
  //console.log(results);
  return results;
}

function treatCombinations(s) {
  var min = false;
  var max = [];
  var maxOdd = false;
  var arr = s;
  var l = arr.length;
  let value = 0;
  let element = document.getElementById("placeBetAreaValue");
  if (element && element.value) value = parseFloat(element.value) / l;

  var i = 0;
  for (; i < l; ) {
    (function (q) {
      var odd = value;
      for (var j in q) {
        odd = odd * q[j];
      }
      if (!min) {
        min = odd;
      } else if (odd < min) {
        min = odd;
      }
      if (!maxOdd) {
        maxOdd = odd;
      } else if (odd > maxOdd) {
        maxOdd = odd;
      }
      max.push(odd);
    })(arr[i]);
    i = i + 1;
  }

  let newMax = 0;
  for (let index = 0; index < max.length; index++) {
    var element1 = max[index];
    newMax += element1;
  }

  return {
    min: min,
    max: max,
    maxOdd: maxOdd,
    combNo: l,
    newMax,
  };
}

export async function setCurrentBalance() {
  var currentBalanceResult = await getCurrentBalance();

  if (!currentBalanceResult) return;

  localStorage.setItem("casinoEnabled", currentBalanceResult.casinoEnabled);
  localStorage.setItem("virtualEnabled", currentBalanceResult.virtualEnabled);
  localStorage.setItem(
    "starCasinoEnabled",
    currentBalanceResult.starCasinoEnabled,
  );
  localStorage.setItem(
    "liveCasinoEnabled",
    currentBalanceResult.liveCasinoEnabled,
  );
  localStorage.setItem(
    "vipCasinoEnabled",
    currentBalanceResult.vipCasinoEnabled,
  );
  localStorage.setItem(
    "blockedSports",
    JSON.stringify(
      currentBalanceResult["blocked_sports"]
        ? currentBalanceResult["blocked_sports"].split(",")
        : [],
    ),
  );

  localStorage.setItem("min_odd", currentBalanceResult.min_odd ? currentBalanceResult.min_odd.toString() : null);

  var coins = [];
  var allText = "";
  var mainBalance;
  const currencyItemTemplace = (currency, value) => {
    return `
    <div class="mmhdr-Header_InfoRow">
      <div class="mmhdr-Header_LeftSideWrapper">
        <div class="mmhdr-UserInfo">
          <div class="mmhdr-UserInfo_AccountInfo">
            <div class="mmhdr-UserInfo_UserName">${username}</div>
            <div class="mmhdr-UserInfo_AccountBalanceWrapper">
              <div class="mmhdr-UserInfo_Balance">${Utils.formatNumber(
                value,
              )}</div>
              <div class="mmhdr-UserInfo_CurrencyCode">${Utils.currencyCode(
                currency,
              )}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
  };

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes(";")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
        allText += currencyItemTemplace(currency, value);
        if (mainBalance && mainBalance.value) {
          if (parseFloat(mainBalance.value) < parseFloat(value))
            mainBalance = { value, currency };
        } else {
          mainBalance = { value, currency };
        }
        // allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
        mainBalance = {
          value: currentBalanceResult.total_coins,
          currency: currentBalanceResult.currency,
        };
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });

        const value = currentBalanceResult.total_coins.split(";")[1];
        mainBalance = { value, currency };
        // allText += currencyItemTemplace(currency, value);
        // allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    }

    if (mainBalance && mainBalance.value) {
      $("div[balance=username]").text(username);
      $("div[balance=value]").text(Utils.formatNumber(mainBalance.value));
      $("div[balance=currency]").text(Utils.currencyCode(mainBalance.currency));
      $("span.profileName.currentBalanceNew").html(
        `${Utils.formatNumber(mainBalance.value)} ${Utils.currencyCode(
          mainBalance.currency,
        )}`,
      );
    }
    $("#mmhdr-currency-wrapper").html(allText);
    // $(".currentBalanceNew").html(allText);

    localStorage.setItem("coins", JSON.stringify(coins));
  }
}

function calculatePrice(value) {
  if (!value) {
    value = document.getElementById("placeBetAreaValue").value;
  }
  let totalValue = 1;

  itemArray.forEach((item) => {
    totalValue = totalValue * item.coefVal;
  });
  totalValue = totalValue * value;

  var size = $("#systemBtn").val();

  if (size && size !== "-1") {
    var odds = [];

    itemArray.forEach((element) => {
      odds.push(element.coefVal);
    });

    var s = getCombinations(odds, size);
    var r = treatCombinations(s);

    $("#winningPrice")[0].innerHTML = `${_t("Fitimi")} ${
      Math.round(r.min * 100) / 100
    } / ${Math.round(r.newMax * 100) / 100}`;
  } else {
    document.getElementById("winningPrice").textContent =
      _t("Fitimi") + " " + Utils.formatNumber(totalValue);
  }
}

window.addEventListener(
  "addToRoom",
  function (e) {
    socket.emit("connectToRoom", { room: e.detail });
  },
  false,
);

window.addEventListener(
  "loadLiveCasino",
  function (e) {
    loadLiveCasino();
  },
  false,
);

window.addEventListener(
  "leaveRoom",
  function (e) {
    let itemArray = JSON.parse(localStorage.getItem("addObject")) || [];
    var check = itemArray.filter((a) => a.gameId == e.detail);
    if (!check || check <= 0) {
      socket.emit("leaveRoom", { room: e.detail });
    }
  },
  false,
);

setDefaults();
window.addEventListener("hashchange", router);
window.addEventListener("load", router);

// document.addEventListener("visibilitychange", function () {
// });

(function () {
  var hidden = "hidden";
  var isVisible = false;
  var lastCheck = new Date().getTime();

  // Standards:
  if (hidden in document)
    document.addEventListener("visibilitychange", onchange);
  else if ((hidden = "mozHidden") in document)
    document.addEventListener("mozvisibilitychange", onchange);
  else if ((hidden = "webkitHidden") in document)
    document.addEventListener("webkitvisibilitychange", onchange);
  else if ((hidden = "msHidden") in document)
    document.addEventListener("msvisibilitychange", onchange);
  // IE 9 and lower:
  else if ("onfocusin" in document)
    document.onfocusin = document.onfocusout = onchange;
  // All others:
  else
    window.onpageshow =
      window.onpagehide =
      window.onfocus =
      window.onblur =
        onchange;

  function onchange(evt) {
    isVisible = !isVisible;
    if (isVisible) {
      const now = new Date().getTime();
      const diffInSeconds = (now - lastCheck) / 1000;
      if (diffInSeconds > 5) {
        window.location.reload();
      }
    } else {
      lastCheck = new Date().getTime();
    }

    setCurrentBalance();
  }

  // set the initial state (but only if browser supports the Page Visibility API)
  if (document[hidden] !== undefined)
    onchange({ type: document[hidden] ? "blur" : "focus" });
})();

function updateScroll() {
  if ($("body").scrollTop() >= 80) {
    $("body").addClass("fixed");
  } else {
    $("body").removeClass("fixed");
  }
}

$(function () {
  $("body").scroll(updateScroll);
  updateScroll();
});

checkForUserGroup();